import { call, put, select } from 'redux-saga/effects';

import showroom from '../../../libs/showroom';
import { Creators as actions } from '../../actions';
import { getConfig, getShowroomQueryParams } from '../../selectors';

/**
 * @param {String} id
 */
function* loadQuote(id) {
    const { showroomApiUrl, token } = yield select(getConfig);
    const showroomQueryParams = yield select(getShowroomQueryParams);

    try {
        const quoteSummary = yield call(showroom.getQuoteSummary, showroomApiUrl, token, id, { ...showroomQueryParams, includeMeta: true });
        yield put(actions.loadQuoteSuccess(quoteSummary));
        return quoteSummary;
    } catch (error) {
        console.log('loadQuote', error)
        yield put(actions.handleError(error));
        return null;
    }
}

export default loadQuote;
